// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetBusinessUnitByIdRequestModel from '../../model/get-business-unit-by-id-request-model';
import GetBusinessUnitByIdRequestDTO from '../dto/get-business-unit-by-id-request-dto';
import dtoSchema from '../schemas/get-business-unit-by-id-request-schema';

export default abstract class GetBusinessUnitByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetBusinessUnitByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {uuid}
  */
  id?: string;

  static toModel(dto: DeepPartial<GetBusinessUnitByIdRequestDTO>): GetBusinessUnitByIdRequestModel;
  static toModel(dto: DeepPartial<GetBusinessUnitByIdRequestDTO> | undefined | null): GetBusinessUnitByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetBusinessUnitByIdRequestDTO> | undefined | null): GetBusinessUnitByIdRequestModel | undefined {
    return dto ? new GetBusinessUnitByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetBusinessUnitByIdRequestModel> | GetBusinessUnitByIdRequestModel): GetBusinessUnitByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetBusinessUnitByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetBusinessUnitByIdRequestModel, can not map to GetBusinessUnitByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
